import { Button, addToast } from '@octano/global-ui';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { downloadFromBlob } from '../../../utils/blob';
import {
  downloadGraduationRecord,
  getGraduationRecordAvailable,
} from '../requests';

const dictPrefix = 'studentsDegreeStudent.graduationRecord';

interface Props {
  studyPlanEnrollmentId: number | string;
}

/**
 * Botón "Generar acta de grado". Consulta al backend si el acta está disponible
 * para esta matrícula; si no lo está (no titulado o el tenant no tiene template),
 * no se muestra.
 */
export default function GraduationRecordButton({
  studyPlanEnrollmentId,
}: Props) {
  const { t } = useTranslation();
  const [available, setAvailable] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    getGraduationRecordAvailable(studyPlanEnrollmentId).then(({ data }) => {
      if (mounted && data) {
        setAvailable(data.available);
      }
    });
    return () => {
      mounted = false;
    };
  }, [studyPlanEnrollmentId]);

  const handleDownload = useCallback(async () => {
    setLoading(true);
    const { data, error } = await downloadGraduationRecord(
      studyPlanEnrollmentId,
    );
    setLoading(false);
    if (error || !data) {
      addToast({
        icon: 'error',
        color: 'danger',
        text: t(`${dictPrefix}.error`),
      });
      return;
    }
    downloadFromBlob(
      new Blob([data], { type: 'application/pdf' }),
      'acta-de-grado.pdf',
    );
  }, [studyPlanEnrollmentId, t]);

  if (!available) {
    return null;
  }

  return (
    <Button
      text={t(`${dictPrefix}.generate`)}
      onClick={handleDownload}
      loading={loading}
      icon="download"
      size="md"
    />
  );
}
